import { ODATA_BASE } from "helpers/api_config";
import { ONAY_SORGULARI } from "../Contacts/Moderation/moderationTypes";

/**
 * Dashboard istatistikleri.
 *
 * Veri dogrudan OData'dan cekiliyor (redux store'a dokunmuyor) — Moderation
 * sayfasindaki yaklasimin ayni. :9093 express wrapper'a bagimlilik yok.
 *
 * Onay bayragi kolonlarinin DB varsayilani olmadigi icin filtreler
 * "false VEYA null" seklinde; aksi halde bayragi hic yazilmamis kayitlar
 * onay kuyrugunda gorunmuyor.
 */

const get = (path) =>
  fetch(`${ODATA_BASE}/${path}`, { headers: { Accept: "application/json" } })
    .then((r) => {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then((j) => j.value || []);

// Onay filtreleri Moderation sayfasiyla ORTAK yerden geliyor
// (Contacts/Moderation/moderationTypes.js -> ONAY_SORGULARI). Daha once ayni
// filtre uc ayri dosyada elle yaziliydi ve ana sayfa 7 turun 5'ini sayiyordu.
const onayYolu = (varlik) => {
  const kayit = ONAY_SORGULARI.find(([ad]) => ad === varlik);
  return `${varlik}?$filter=${kayit ? kayit[1] : ""}&$select=ID`;
};

/** Onay bekleyen icerik turleri — Moderation sayfasiyla ayni kurallar */
export const PENDING_SOURCES = [
  {
    key: "jobAdvert",
    label: "İş İlanı",
    icon: "bx-briefcase",
    color: "warning",
    path: onayYolu("Job_Advertisement"),
  },
  {
    key: "company",
    label: "Firma",
    icon: "bx-buildings",
    color: "info",
    path: onayYolu("Company"),
  },
  {
    key: "forum",
    label: "Forum Konusu",
    icon: "bx-conversation",
    color: "primary",
    path: onayYolu("Forum"),
  },
  {
    key: "forumComment",
    label: "Forum Yorumu",
    icon: "bx-comment",
    color: "secondary",
    path: onayYolu("Forum_Comment"),
  },
  {
    key: "newsComment",
    label: "Aktüel Yorumu",
    icon: "bx-news",
    color: "danger",
    path: onayYolu("News_Comment"),
  },
  {
    // 2026-09-01: Onay Bekleyenler ekraninda 7 tur varken ana sayfa yalnizca
    // 5'ini sayiyordu; yonetici eksik rakam goruyordu. Ikisi eklendi.
    key: "articleDayComment",
    label: "Söz Sizde Yorumu",
    icon: "bx-message-square-detail",
    color: "dark",
    path: onayYolu("ArticleDay_Comment"),
  },
  {
    key: "companyComment",
    label: "Firma Yorumu",
    icon: "bx-star",
    color: "success",
    path: onayYolu("Company_Comment"),
    // Uc 2026-09-02 itibariyla yayinda; "optional" isareti yalnizca gecici
    // servis hatasinda ana sayfanin hata bandi acmamasi icin duruyor.
    optional: true,
  },
];

/** Gunluk sayim icin izlenen tablolar ve tarih alanlari */
const DAILY_SOURCES = [
  {
    key: "jobAdvert",
    label: "İlan",
    color: "#f39c12",
    path: "Job_Advertisement?$select=ID,Job_Advertisement_DateTime",
    dateField: "Job_Advertisement_DateTime",
  },
  {
    key: "company",
    label: "Firma",
    color: "#16a085",
    path: "Company?$select=ID,Company_Add_DateTime",
    dateField: "Company_Add_DateTime",
  },
  {
    key: "newsComment",
    label: "Aktüel Yorumu",
    color: "#e74c3c",
    path: "News_Comment?$select=ID,News_Comment_Created_DateTime",
    dateField: "News_Comment_Created_DateTime",
  },
  {
    key: "forumComment",
    label: "Forum Yorumu",
    color: "#3498db",
    path: "Forum_Comment?$select=ID,Forum_Comment_Created_DateTime",
    dateField: "Forum_Comment_Created_DateTime",
  },
];

/**
 * Satin alma / gelir kaynaklari.
 *
 * Panelin ana sayfasinda gelirle ilgili HICBIR gosterge yoktu; oysa iki
 * tabloda 198 satin alma kayitli. Isletme acisindan en onemli rakam
 * burasi oldugu icin ana sayfaya tasindi.
 *
 *   Job_Advertisement_Users_Complated     -> one cikan ILAN satin almalari
 *   Company_Advertisement_Users_Complated -> one cikan REHBER satin almalari
 */
const PURCHASE_SOURCES = [
  { key: "ilan",   path: "Job_Advertisement_Users_Complated?$select=ID,Complated_Finish_Date" },
  { key: "rehber", path: "Company_Advertisement_Users_Complated?$select=ID,Complated_Finish_Date" },
];

/** Bitis tarihi gecmemisse satin alma hala aktiftir. */
const aktifMi = (kayit) => {
  if (!kayit || !kayit.Complated_Finish_Date) return false;
  const bitis = new Date(kayit.Complated_Finish_Date);
  return !isNaN(bitis.getTime()) && bitis.getTime() > Date.now();
};

const dayKey = (d) => {
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return null;
  // Yerel gune gore YYYY-MM-DD
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${dt.getFullYear()}-${m}-${day}`;
};

/** Son N gunun (bugun dahil) gun anahtarlari, eskiden yeniye */
export const lastDays = (n) => {
  const out = [];
  const today = new Date();
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    out.push(dayKey(d));
  }
  return out;
};

/**
 * Tum istatistikleri toplar.
 * Her kaynak bagimsiz: biri patlarsa digerleri yine gelir.
 */
export async function loadDashboardStats(dayCount = 7) {
  const days = lastDays(dayCount);
  const todayKey = days[days.length - 1];

  const pending = {};
  const daily = {};
  const series = {};
  const errors = [];
  const satinAlma = { toplam: 0, aktif: 0, dolmus: 0, ilan: 0, rehber: 0, birimFiyat: null };

  await Promise.all([
    ...PENDING_SOURCES.map(async (s) => {
      try {
        const rows = await get(s.path);
        pending[s.key] = rows.length;
      } catch (e) {
        // Henuz yayina alinmamis uclar kullaniciya hata olarak gosterilmez
        if (s.optional) {
          pending[s.key] = 0;
        } else {
          pending[s.key] = null;
          errors.push(s.label);
        }
      }
    }),
    ...DAILY_SOURCES.map(async (s) => {
      try {
        const rows = await get(s.path);
        const counts = {};
        days.forEach((d) => (counts[d] = 0));
        let today = 0;
        rows.forEach((r) => {
          const k = dayKey(r[s.dateField]);
          if (!k) return;
          if (k in counts) counts[k] += 1;
          if (k === todayKey) today += 1;
        });
        daily[s.key] = today;
        series[s.key] = days.map((d) => counts[d]);
      } catch (e) {
        daily[s.key] = null;
        series[s.key] = days.map(() => 0);
        errors.push(s.label);
      }
    }),
    ...PURCHASE_SOURCES.map(async (s) => {
      try {
        const rows = await get(s.path);
        satinAlma[s.key] = rows.length;
        satinAlma.toplam += rows.length;
        const aktif = rows.filter(aktifMi).length;
        satinAlma.aktif += aktif;
        satinAlma.dolmus += rows.length - aktif;
      } catch (e) {
        errors.push("Satın alma");
      }
    }),
    (async () => {
      // Birim fiyat tek kayitlik Purchase_Options tablosundan
      try {
        const rows = await get("Purchase_Options?$select=Purchase_Options_Price");
        const p = rows.length > 0 ? Number(rows[0].Purchase_Options_Price) : NaN;
        satinAlma.birimFiyat = isNaN(p) ? null : p;
      } catch (e) {
        satinAlma.birimFiyat = null;
      }
    })(),
    (async () => {
      // Toplam ilan sayisi: ana sayfada Uye/Aktuel/Firma/Forum karti vardi
      // ama uygulamanin ana bolumlerinden ILANLAR icin kart yoktu.
      try {
        const rows = await get("Job_Advertisement?$select=ID");
        satinAlma.ilanToplam = rows.length;
      } catch (e) {
        satinAlma.ilanToplam = null;
      }
    })(),
  ]);

  return { pending, daily, series, days, errors, satinAlma, sources: DAILY_SOURCES };
}

export { DAILY_SOURCES };
